// extracted by mini-css-extract-plugin
export default {"reportTableHead":"TableHeader_reportTableHead__BL4+O","headerContent":"TableHeader_headerContent__zFdfA"};